import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-px-sm" }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import BaseModal from '../wrappers/BaseModal.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { useUserStore } from '../../store/useUserStore'
import { storeToRefs } from 'pinia'
const legalCA = `
By clicking “I Agree” below, I certify that, during the time period indicated, I was (1) required to accurately and completely record, to the minute, my time worked each day, including any sync time and any commuting time over 30 minutes; (2) entitled to take a full 30-minute, duty-free meal break that must begin no later than the end of my fifth hour of work; (3) entitled to take a second 30-minute, duty-free meal break that must begin no later than the end of my tenth hour of work, but am entitled to waive this right with the consent of the Company as long as I took my first meal break and work no more than 12 hours; (4) required to accurately record the start and stop times, to the minute, of my meal breaks; and (5) authorized and permitted to take a full 10-minute, duty-free rest break for every four hours worked, or major fraction thereof. I further certify that I have not performed any off-the-clock work, I have been provided the opportunity to take all meal breaks as stated above, and I have been authorized and permitted to take all rest breaks as stated above, or, if not, I have reported the issue to my supervisor. 
`
const legalNWUSA = `
By clicking “I Agree” below, I certify that, during the time period indicated, I have (1) accurately and completely recorded all of my time worked each day, including any sync time and any commuting time over 30 minutes; (2) not performed any off-the-clock work; (3) accurately recorded to the minute my start and stop times; (4) had the opportunity to take a 30-minute, duty free unpaid meal break for every 5 hours I worked; and (5) had the opportunity to take ten (10) minute duty-free paid rest breaks for every 4 hours worked, or major fraction thereof, and, to the extent that I did not take any such breaks, I voluntarily waived my right to take them. 
`
const legalOthersUSA = `
By clicking “I Agree” below, I certify that, during the time period indicated, I have (1) accurately and completely recorded all of my time worked each day, including any sync time and any commuting time over 30 minutes; (2) not performed any off-the-clock work; (3) accurately recorded to the minute my start and stop times; and (4) had the opportunity to take a 30-minute, duty free unpaid meal break for every 5 hours I worked. 
`

export default /*#__PURE__*/_defineComponent({
  __name: 'FormPayrollCert',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "endDay"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const value = useModelWrapper(props, emit)

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
const agree = ref()
const options = computed(() => [
  { label: label('agree'), value: true },
  { label: label('disagree'), value: false },
])

const endDay = () => {
  if (typeof agree.value !== 'undefined') {
    emit('endDay', agree.value)
  }
}

//california
const legalCAN = {
  en_US: `
  By clicking “I Agree” below, I certify that, during the time period indicated, I have (1) accurately and completely recorded all of my time worked each day, including any sync time; (2) not performed any off-the-clock work; (3) accurately recorded to the minute my start and stop times; and (4) had the opportunity to take a 30-minute, duty free unpaid meal break for every 5 hours I worked.  
  `,
  es_MX: `
  By clicking “I Agree” below, I certify that, during the time period indicated, I have (1) accurately and completely recorded all of my time worked each day, including any sync time; (2) not performed any off-the-clock work; (3) accurately recorded to the minute my start and stop times; and (4) had the opportunity to take a 30-minute, duty free unpaid meal break for every 5 hours I worked.  
  `,
  fr_CA: `
  En cliquant «Je suis d'accord» ci-dessous, j'atteste que, pour la période de temps indiquée, (1) j'ai enregistré avec précision et dans sa totalité mon temps de travail pour chaque journée, incluant le temps de synchronisation; (2) je n'ai pas travaillé en dehors des heures normales; (3) j'ai enregistré avec précision, à la minute près, l'heure à laquelle j'ai commencé et l'heure à laquelle j'ai terminé; et (4) j'ai eu l'occasion de prendre une pause déjeuner de 30 minutes, sans solde, par tranche de 5 heures de travail.
  `,
}
const NWUSA = ['CO', 'NV', 'KY', 'WA', 'MN', 'OR']

const { country: usersCountry, state: usersState, language } = storeToRefs(useUserStore())

const legalVerbiage = computed(() => {
  if (usersCountry.value == 'Canada') return legalCAN[language.value]
  if (usersState.value == 'CA') return legalCA
  if (NWUSA.includes(usersState.value)) return legalNWUSA
  return legalOthersUSA
})

return (_ctx: any,_cache: any) => {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(label('payrollCertLang')), 1)
    ]),
    content: _withCtx(() => [
      _createTextVNode(_toDisplayString(legalVerbiage.value) + " ", 1),
      _createElementVNode("div", null, [
        _createVNode(_component_q_btn_toggle, {
          modelValue: agree.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agree).value = $event)),
          options: options.value
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    actions: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_btn, {
        rounded: "",
        flat: "",
        label: label('close')
      }, null, 8, ["label"]), [
        [_directive_close_popup]
      ]),
      _createVNode(_component_q_btn, {
        rounded: "",
        color: "primary",
        onClick: endDay
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(label('endDay')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})